export default function RepairNotReplace() {
  return (
    <section className="bg-plum py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto text-center">
          <p className="font-serif italic text-rose-200 text-sm md:text-base mb-3">
            Économique et écologique
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
            <span className="font-serif italic">Réparer</span> plutôt que remplacer la fenêtre
          </h2>
          <p className="text-base md:text-lg text-rose-100 leading-relaxed mb-8 max-w-2xl mx-auto">
            Changer une fenêtre oscillo-battant coûte entre 800 et 1 500 € l'unité, pose comprise. Le réglage ou le remplacement d'une pièce usée coûte 10 à 20 fois moins cher. Chez DF PRO, nous remplaçons la pièce défectueuse — gond, paumelle, galet, crémone — et nous laissons la menuiserie intacte. Votre fenêtre retrouve son étanchéité, sa fluidité et son aspect esthétique, sans travaux lourds ni poussière.
          </p>
          <a
            href="tel:0374471036"
            className="inline-flex items-center gap-2 bg-coral text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-coral-light transition-colors"
          >
            <i className="ri-phone-line" />
            Appeler le 03 74 47 10 36
          </a>
        </div>
      </div>
    </section>
  );
}